import { useDispatch, useSelector } from "react-redux";
import { Button } from "@chakra-ui/react";
import { MdAdd } from "react-icons/md";
import { Currency } from "utils/numberFormat";
import { RiSubtractFill } from "react-icons/ri";
import { ReactComponent as ELD } from "assets/svg/ELD.svg";
import { ReactComponent as Cart } from "assets/svg/cart.svg";
import {
  removeFromCart,
  addQuantity,
  subQuantity,
  selectAllCartItems,
} from "../store/cartSlice";

const FoodCart = () => {
  const cartItems = useSelector(selectAllCartItems);
  const totalPrice = useSelector((state) => state.sale.cartSlice.totalPrice);

  if (cartItems.length === 0) {
    return (
      <div className="mt-4">
        <div className="flex flex-col gap-4">
          {/* Cart items */}
          <div className="text-center text-gray-600 py-10">
            Хоол сонгоогүй байна.
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="mt-4">
      <div className="flex flex-col gap-4">
        {/* Cart items */}
        <div>
          {cartItems.map((item, index) => (
            <CartItem key={index} item={item} />
          ))}
          {/* Divider */}
          <div className="border w-full mt-4" />

          {/* Total Price */}
          <div className="mt-4 flex flex-row items-center justify-between py-3 pr-3 pl-4 rounded-md border bg-white">
            <h4 className="font-bold">НИЙТ ДҮН</h4>
            <h4 className="font-bold">
              <Currency value={totalPrice} />
            </h4>
          </div>

          {/* Payment btn */}
          <Button
            colorScheme="customGreen"
            variant="solid"
            className="my-2 mt-4"
          >
            <Cart /> <h4 className="ml-2 text-white font-bold">ТӨЛӨХ</h4>
          </Button>
        </div>
      </div>
    </div>
  );
};

const CartItem = ({ item }) => {
  const dispatch = useDispatch();

  return (
    <div className="mb-2 flex flex-row items-start justify-between w-full pt-2 pb-3 pr-3 pl-4 rounded-md border bg-white">
      {/* Food and Count */}
      <div className="flex flex-col gap-3">
        <h5 className="font-semibold">{item.food_name}</h5>
        <div className="flex w-fit overflow-hidden rounded-md border">
          <Button
            colorScheme="customGray"
            variant="solid"
            px="0"
            borderRadius={0}
            onClick={() => dispatch(subQuantity(item.id))}
          >
            <RiSubtractFill color="white" fontSize={22} />
          </Button>
          <input
            value={item.quantity}
            disabled
            className="w-[40px] text-center font-bold"
            type="number"
            onWheel={(e) => e.target.blur()}
            min="1"
          />
          <Button
            colorScheme="customGreen"
            variant="solid"
            px="0"
            borderRadius={0}
            onClick={() => dispatch(addQuantity(item.id))}
          >
            <MdAdd color="white" fontSize={22} />
          </Button>
        </div>
      </div>
      {/* Price */}
      <div className="flex items-center gap-4">
        <h5 className="font-semibold">
          {item.quantity} x <Currency value={item.price} />
        </h5>
        <Button
          colorScheme="red"
          px="0"
          onClick={() => dispatch(removeFromCart(item.id))}
        >
          <ELD />
        </Button>
      </div>
    </div>
  );
};

export default FoodCart;
